import { render } from "./AccountSettingIndex.vue?vue&type=template&id=c8d891ce"
import script from "./AccountSettingIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__